module.exports = __webpack_public_path__ + "static/property-3-d438626f4cc37cb1ca5d8eb8b6978f81.jpg";